import React from 'react';
import Form from '~/common/components/Form';
import SingleImageUploader from "~/common/components/FormImageUploader/SingleImageUploader";
import { UPLOAD_TYPE } from "~/common/constants/upload";

const ImgUploadForm = ({useForm}) => {
    return (
            <Form useForm={useForm} className="profile-img">
				<SingleImageUploader
					name="UserProfile.img"
					type={UPLOAD_TYPE.USER_PROFILE}
					height="160px"
					width="160px"
					className={"profile-img"}
					round
				/>
			</Form>
    );
};

export default ImgUploadForm;